import { Injectable } from '@angular/core';
import { InjectionToken } from '@angular/core';
import { Inject } from '@angular/core';
import { HttpClient, HttpParams} from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject, Observable, of, Subject, Subscription, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
// import moment from 'moment-timezone';
import { saveAs } from 'file-saver';
import * as FileSaver from 'file-saver';
import moment from 'moment';
import 'moment-timezone';
import { BADHINTS } from 'dns';
@Injectable({
  providedIn: 'root'
})
export class TestService {
  private url : string;
public inItFlowChartSteps: BehaviorSubject<any> = new BehaviorSubject('');
public isCardViewActive  = new BehaviorSubject(true);
loadBranches = new BehaviorSubject<any>(undefined);
reloadHITL = new BehaviorSubject<any>(undefined);

sampleJSON =  [];

testStepsList = new BehaviorSubject(null)
testStepsListForEdit = new BehaviorSubject(null)
  baseURL: any;
  createCopy: any;
  eventData: any;
  isRecording: any;
  recordMode: any;
  testCaseDataForUpdate: any;
  cardView: any = true;
  edi: any;
  selectedSteps: any = [];
  selectedStepsData = new BehaviorSubject([]);
  enableCutPaste = new BehaviorSubject(false);
  enableCopyPaste =  new BehaviorSubject(false);
  setSelectedIndex = new BehaviorSubject(null);
  isRecordingSub = new BehaviorSubject(false);
  constructor(

    private http: HttpClient,
    private toastr: ToastrService,
    private router: Router,
    private cookieService: CookieService,
    private toastrService: ToastrService,
    @Inject( DOCUMENT ) private document: Document

  ) {
    this.url=environment.baseUrl;
   }

   private subjectForTestStepFlow = new Subject<any>();
   private subjectForToken = new Subject<any>();
   sendStepData(stepData: any) {
    this.subjectForTestStepFlow.next({ test: stepData });
}

clearMessages() {
    this.subjectForTestStepFlow.next(null);
}

getStepData(): Observable<any> {
    return this.subjectForTestStepFlow.asObservable();
}
sendTokenData(tokenData: any) {
  this.subjectForToken.next({ tokenData });
}
getTokanData(): Observable<any> {
  return this.subjectForToken.asObservable();
}

  getAction(projectType): Observable<any>{

  return this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/action/' + projectType);
}

getGroupedAction(): Observable<any>{

  return this.http.get(this.url + '/HuLoopRest/huloop/' + 'flowchart/functiongroup');
}

  getFunction(): Observable<any>{
    return this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/function');
  }

  getTestStepInfo(actionName,functionName): Observable<any>{
    return this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/info/'+actionName+'/'+functionName);
  }



  getLocatorSuite(projectId: any){
   // console.log("inside service : ", projectId);
    return this.http.get(this.url + '/HuLoopRest/huloop/' + 'locator/locatorSuite/' + projectId)

  }
  getRcLocatorSuite(rcId: any){
    // console.log("inside service : ", projectId);
     return this.http.get(this.url + '/HuLoopRest/huloop/' + 'locator/componentSuite/' + rcId)
 
   }
  getAllProjectSetting(_projectId: any){

    return this.http.get(this.url + '/HuLoopRest/huloop/' + 'project/getAllProjectSettings/'+ _projectId)
  }

  addTestCase(projectId,suiteId,objectForAddition){
    return this.http.post(this.url + '/HuLoopRest/huloop/test/addTestCase/' + projectId + '/'+suiteId,objectForAddition)
  }
editTestCase(projectId,caseId,objectForupdate){
  return this.http.post<any>(this.url + '/HuLoopRest/huloop/test/editTestCase/' + projectId + '/' + caseId + '/false',objectForupdate)
}

assiciationTestCase(projectId,testId,ObjectForAssociation){
  return this.http.post(this.url+'/HuLoopRest/huloop/test/editTestCaseTextData/'+projectId+'/'+testId,ObjectForAssociation)
}

editTestSuiteData(objectForEdit){
  return this.http.post(this.url+'/HuLoopRest/huloop/test/editTestSuiteData',objectForEdit);
}

getSuitData(projectId,suiteId){
  return this.http.get(this.url+'/HuLoopRest/huloop/test/testSuiteData/' + projectId + '/' + suiteId);
}

includeTestSuite(projectId: string,testId :string, newTestId :string){
  return this.http.post(this.url+'/HuLoopRest/huloop/test/includeTestSuite/' + projectId + '/' + testId + "/" + newTestId , '');
}


deleteTestSuite(projectId : string, testId : string, deleteId : string)
{
   return this.http.delete(this.url + "/HuLoopRest/huloop/test/removeTestSuite/" + projectId + "/" + testId + "/" + deleteId);
}

 getAllChildTestDir(projectId){
      return this.http.get(this.url + '/HuLoopRest/huloop/'+ 'test/all/' + projectId );
    }
getTestSuiteTestReport(projectId,reportId,testDataId,path,title,iteration?:any){
  //http://beatblipdemo.agreeya.net/HuLoopRest/huloop/testReport/testSuite/6204b81860b2a68e69d55df1/6213366160b2aacb6f65aa2b/6204b81860b2a68e69d55df7/,PJM_POC_Database_Module,/PJM_POC_Database_Suite_1/0
  if(title.includes('\\')){
    let x = title.split("\\");
    return this.http.get(this.url+ '/HuLoopRest/huloop/'+'testReport/testSuite/' + projectId + '/' + reportId+'/'+testDataId+'/' + iteration)
  }else{
    return this.http.get(this.url+ '/HuLoopRest/huloop/'+'testReport/testSuite/' + projectId + '/' + reportId+'/'+testDataId+'/' + path + '/' + title + '/' + iteration)
  }
}
getTestProjectReport(projectId,testProjectReportId){
  return (this.url + 'testReport/'+projectId+'/'+testProjectReportId)
}
getFailedReason(data) {
  if (data) {
      var regex = /<br\s*[\/]?>/gi;
      return data.replace(regex, "\n");
  } else {
      return data;
  }
}
getDuration = function (startTime, endTime) {
  var start = moment(startTime, "x"); //console.log(start);
  //    console.log(start.tz('America/Los_Angeles').format('MM/DD/YY H:mm:ss.sss'));
 //  console.log(start.tz('Asia/Calcutta').format('MM/DD/YY H:mm:ss.sss'));
  var end = moment(endTime, "x");
  var diffInMilliseconds = end.diff(start);
  var intvalue = diffInMilliseconds / 1000;
  return intvalue;
};

getTestCaseTestReport(projectId,reportId,testDataId,path,dataIteration){
if(path.includes("\\")){
    let x = path.split("\\");
    return this.http.get(this.url+'/HuLoopRest/huloop/'+'testReport/testCase/' + projectId + '/' + reportId+'/' + testDataId + '/'+dataIteration+'/' +x[0] + '/' +x[1])
  }else{
    return this.http.get(this.url+'/HuLoopRest/huloop/'+'testReport/testCase/' + projectId + '/' + reportId+'/' + testDataId + '/'+dataIteration+'/' +path)
  }
  //http://beatblipdemo.agreeya.net/HuLoopRest/huloop/testReport/testCase/6204b81860b2a68e69d55df1/621336c060b2aacb6f65aa3f/6204b81960b2a68e69d55e02,0/0/,PJM_POC_Database_Module,PJM_POC_Database_Suite_1,
}

getTestCaseTestReportV2(projectId,reportId,testDataId,path,dataIteration, pageNumber, pageSize){
    return this.http.get(this.url+'/HuLoopRest/huloop/'+'testReport/testCaseV2/' + projectId + '/' + reportId+'/' + testDataId + '/'+dataIteration+'/' +path+ '/'+ pageNumber+'/'+ pageSize);
}

//http://beatblipdemo.agreeya.net/HuLoopRest/huloop/test/copyTestSteps/620f2f1660b2aacb6f65a20a/6218b02460b2aacb6f65dc62/6218b02460b2aacb6f65dc62/5/COPY
pasteSteps(projectId, moduleId,caseId,index, pasteObj){
  return this.http.post(this.url+'/HuLoopRest/huloop/test/copyTestSteps/'+projectId+'/'+moduleId+'/'+caseId+'/'+index+'/COPY',pasteObj)
}
cutPaste(projectId, moduleId,caseId,index, pasteObj){
  //http://beatblipdemo.agreeya.net/HuLoopRest/huloop/test/cutTestSteps/61276c94a1f486a24017af5e/61e651b260b20b7f34ed7ccc/61e651b260b20b7f34ed7ccc/3/CUT
  return this.http.post(this.url+'/HuLoopRest/huloop/test/cutTestSteps/'+projectId+'/'+moduleId+'/'+caseId+'/'+index+'/CUT',pasteObj)
}
logFailedBug(projectId, testProjectReportId, testDataId, testSuiteId, dataIterationIndex , body)
{
  return this.http.post(this.url + '/HuLoopRest/huloop/testReport/testCaseLogBug/' + projectId + "/" + testProjectReportId + '/' + testDataId + '/' + testSuiteId + "/" + dataIterationIndex , body)
}

exportTestCaseAsJunit(entity,Name) {
  var uploadUrl = this.url + '/HuLoopRest/huloop/test/exportTestCaseDataAsJunit';
  // this.toastr.clear();
  // this.toastr.success('Exporting test case...&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa fa-circle-o-notch fa-spin"></i></i>', null, {
  //     extendedTimeOut: 0,
  //     timeOut: 0,
  //     enableHtml: true
  // });
  this.http.post(uploadUrl, entity, {
      headers: {
          "accept": "application/octet-stream"
      },
      responseType: 'arraybuffer'
  }).subscribe((response) =>{
      var fileName = Name + '.zip';
      var data = new Blob([response], {
          type: 'application/octet-stream'
      });
      FileSaver.saveAs(data, fileName);
      this.toastr.clear();
      this.toastr.success('Testcase exported successfully');
  })
}

exportTestSuiteAsJunit(entity,Name) {
  var uploadUrl = this.url + '/HuLoopRest/huloop/test/exportTestSuiteDataAsJunit';
  this.toastr.clear();
  this.toastr.success('Exporting test case...&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa fa-circle-o-notch fa-spin"></i></i>', null, {
      extendedTimeOut: 0,
      timeOut: 0,
      enableHtml: true
  });
  this.http.post(uploadUrl, entity, {
      headers: {
          "accept": "application/octet-stream"
      },
      responseType: 'arraybuffer'
  }).subscribe((response) =>{
      var fileName = Name + '.zip';
      var data = new Blob([response], {
          type: 'application/octet-stream'
      });
      FileSaver.saveAs(data, fileName);
      this.toastr.clear();
      this.toastr.success('exported successfully');
  })
}

//http://beatblipdemo.agreeya.net/HuLoopRest/huloop/test/copyTestSuite/61276c94a1f486a24017af5e/6213353260b2aacb6f65aa21

pasteSuite(projectId,moduleId,suiteId){
  return this.http.post(this.url+'/HuLoopRest/huloop/test/copyTestSuite/'+projectId +'/'+moduleId, suiteId)
}
//http://beatblipdemo.agreeya.net/HuLoopRest/huloop/test/editTestFile
editTestFile(payloadData){
  return this.http.post(this.url+'/HuLoopRest/huloop/test/editTestFile',payloadData);
}
editTestFileStep(payloadData){//http://beatblipdemo.agreeya.net
  return this.http.post(this.url+'/HuLoopRest/huloop/test/editTestFileStep',payloadData);
}
getTestSuiteData(projectId,suiteId){
  //http://beatblipdemo.agreeya.net/HuLoopRest/huloop/test/testSuiteData/61276c94a1f486a24017af5e/61a5e05568b4d67eb853c7fd
  return this.http.get(this.url+'/HuLoopRest/huloop/test/testSuiteData/'+ projectId + '/' + suiteId)
}
//http://beatblipdemo.agreeya.net/HuLoopRest/huloop/test/includeTestCase/61276c94a1f486a24017af5e
getIncludedTestCases(projectId){
  return this.http.get(this.url+'/HuLoopRest/huloop/test/includeTestCase/'+projectId)
}
multiAssociation(projectId,suiteId,dataId,list){
  //http://beatblipdemo.agreeya.net/HuLoopRest/huloop/test/associateTextData/61276c94a1f486a24017af5e/6204dbe160b2a68e69d55fbe/620e089c60b2cbc6a74746cd
return this.http.post(this.url + '/HuLoopRest/huloop/test/associateTextData/'+projectId + '/' + suiteId +'/'+ dataId,list)
}
multiDissociation(projectId,suiteId,list){
  //http://beatblipdemo.agreeya.net/HuLoopRest/huloop/test/disassociateTextData/61276c94a1f486a24017af5e/6204dbe160b2a68e69d55fbe
  return this.http.post(this.url + '/HuLoopRest/huloop/test/disassociateTextData/'+projectId + '/' + suiteId , list)

}

setRecordingUrl(param1) {
  this.baseURL = param1;
}
getRecordingUrl() {
  return this.baseURL;
}
setEventData(eData) {
  this.eventData = eData;
}
getEventData(): any {
  return this.eventData;
}

setCopyStatus (param1) {
  this.createCopy = param1;
}
getCopyStatus () {
  return this.createCopy;
}

setRecordingStatus(data1) {
  this.isRecording = data1;
}
getRecordingStatus () {
  return this.isRecording;
}
setRecordMode(mode) {
  this.recordMode = mode;
}
getRecordMode() {
  return this.recordMode;
}
setRecordingStatusSub(data1) {
  this.isRecordingSub.next(data1);
}
getRecordingStatusSub () {
 return this.isRecordingSub.asObservable();
}
setDataForUpdate(data){
  this.testCaseDataForUpdate = data;

}

getDataForUpdate(){
return this.testCaseDataForUpdate;
}

saveRecordData (projectId, testSuiteFileId, testCaseId, testCaseData, isClone) {
 return this.http.post(this.url + '/HuLoopRest/huloop/recordCommandImport/upload/'+projectId + '/' + testSuiteFileId+ '/'+testCaseId + '/'+ isClone, testCaseData)
}
/** Translate recorded commands without replacing the case (used by Mouse Sequence). */
getMidRecorderPreview(projectId, testSuiteFileId, testCaseId, testCaseData) {
  return this.http.post(this.url + '/HuLoopRest/huloop/recordCommandImport/upload/' + projectId + '/' + testSuiteFileId + '/' + testCaseId, testCaseData);
}
/** Append translated recorder steps at index without wiping the case. */
saveMidRecorderData(projectId, testSuiteFileId, testCaseId, isClone, index, testCaseData) {
  return this.http.post(this.url + '/HuLoopRest/huloop/recordCommandImport/upload/' + projectId + '/' + testSuiteFileId + '/' + testCaseId + '/' + isClone + '/' + index, testCaseData);
}
//https://beatblipdemo.agreeya.net:8443/HuLoopRest/huloop/test/dynamicDropDownData/62cd0b02e4b010def570e078/autoitscripthandler
getdynamicDropDownData(methodName, projectId){
 return this.http.get(this.url+'/HuLoopRest/huloop/test/dynamicDropDownData/'+projectId+'/'+methodName)
}

setView(data){
  this.isCardViewActive.next(data );
  this.cardView = data;

}
  getView() {
    return this.isCardViewActive.asObservable();
    // return this.cardView;
  }
  encryptTestStepParam(peojectId, stepId, stepIndex, encryptObj) {
    return this.http.put(this.url + '/HuLoopRest/huloop/test/encryptStep/' + peojectId + '/' + stepId + '/' + stepIndex, encryptObj)
  }
  decryptTestStepParam(peojectId, stepId, stepIndex, encryptObj) {
    return this.http.put(this.url + '/HuLoopRest/huloop/test/decryptStep/' + peojectId + '/' + stepId + '/' + stepIndex, encryptObj)
  }

  runtimeTestStep(peojectId, stepId, stepIndex, runtimeObj) {
    return this.http.put(this.url + '/HuLoopRest/huloop/test/runtimeTestStep/' + peojectId + '/' + stepId + '/' + stepIndex, runtimeObj)
  }

  shareTestSteps(list) {
    this.testStepsList.next(list);
  }
  getTestSteps() {
    return this.testStepsList.asObservable();
  }

  fetchBranches()
  {
    return this.sampleJSON;
  }
  setStepForEdit(list) {
    this.testStepsListForEdit.next(list);
  }
  getStepForEdit() {
    return this.testStepsListForEdit.asObservable();
  }
createBranch(projectId, testSuiteId , objectToCreate){
  ///branch/create/664b5ae8a0a3102ef7a76309/664b5ae8a0a3102ef7a7630b
  return this.http.post(this.url + '/HuLoopRest/huloop/branch/create/' + projectId + '/' + testSuiteId , objectToCreate)
}
getBranchList(projectId, testSuiteId){
  return this.http.get(this.url + '/HuLoopRest/huloop/branch/testSuiteData/' + projectId + '/' + testSuiteId)
}

getSelectedStep()
{
  return this.selectedSteps;
}

updatedSelectedStep(stepData)
{
  this.selectedSteps = stepData;
}



updateBranch(projectId, testSuiteId , objectToCreate){
  
  return this.http.post(this.url + '/HuLoopRest/huloop/branch/updateTitle/' + projectId + '/' + testSuiteId , objectToCreate)

  // http://localhost:8091/HuLoopRest/huloop/branch/updateTitle/664b5ae8a0a3102ef7a76309/664b5ae8a0a3102ef7a7630b
// REQUEST BODY ::
 
// {
//     "branch": [
//         {
//             "id":"6672841eef9ff345177fa5d9",
//             "branch": "Swapnil Branch",
//             "description": "This is branch two"
//         },
//         {
//             "id":"6672842def9ff345177fa5db",
//             "branch": "Vivek Branch",
//             "description": "This is branch two"
//         }
//     ]
// }
 
// DELETE BRANCH :: 
// http://localhost:8091/HuLoopRest/huloop/branch/delete/664b5ae8a0a3102ef7a76309/664b5ae8a0a3102ef7a7630b/6672841eef9ff345177fa5d9
}



    // runtimeTestStep(peojectId, stepId,stepIndex, runtimeObj){
    //   return this.http.put(this.url+'/HuLoopRest/huloop/test/runtimeTestStep/'+ peojectId +'/'+ stepId +'/'+ stepIndex , runtimeObj)
    //   }

      getLoggingResource(testcseId){
        return this.http.post(this.url+'/HuLoopRest/huloop/loggingResource/checkRecord/' + testcseId,'')
      }
      editDelete(projectId,caseId,objectForupdate){
        return this.http.post(this.url + '/HuLoopRest/huloop/test/editDelete/' + projectId + '/' + caseId + '/false',objectForupdate)
      }  
      deleteBranch(projectId, testSuiteId , branchId){
        return this.http.delete(this.url + '/HuLoopRest/huloop/branch/delete/' + projectId + '/' + testSuiteId +'/'+ branchId)
      
      }
      setSelectedData(data){
        this.selectedStepsData.next(data);
      }
      getSelectedData(){
        return this.selectedStepsData.asObservable()
      }
      setCutEnable(data){
       this.enableCutPaste.next(data);;
      }
      getCutEnable(){
       return this.enableCutPaste.asObservable();
      }
      setCopyEnable(data){
      this.enableCopyPaste.next(data);
      }
      getCopyEnable(){
      return this.enableCopyPaste.asObservable();
      }

      checkRc(rcId,projectId){
        //component/copy/{componentId}/{projectId}
        return this.http.post(this.url + '/HuLoopRest/huloop/component/copy/' + rcId + '/' + projectId , '')
      }  
      
}

  